import * as z from 'zod';

import { booleanMutationSchema } from '@/_schemas/generic';

import { brandQuerySchema } from './brand-query-schema';

export const brandUpdateSchema = brandQuerySchema
  .omit({ agreement_logo: true, logo: true, logo_light: true, icon: true })
  .extend({
    logo: z.array(z.number()).nullable(),
    logo_light: z.array(z.number()).nullable(),
    icon: z.array(z.number()).nullable(),
    agreement_logo: z.array(z.number()).nullable(),
    phone_numbers: z.array(z.number()),
    addresses: z.array(z.number()),
    invoice_logo: z.array(z.number()).nullable(),
    hide_online_payments: booleanMutationSchema(),
  });

export type BrandUpdateSchema = z.infer<typeof brandUpdateSchema>;

export const brandCreateSchema = brandUpdateSchema.pick({
  name: true,
  code: true,
  website: true,
  email: true,
  billing_email_address: true,
  agreement_statement: true,
  invoice_disclaimer: true,
  legal_name: true,
  hide_online_payments: true,
});

export type BrandCreateSchema = z.infer<typeof brandCreateSchema>;
